/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CoffeeIcon
 */
export default class CoffeeIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18.451 11c.612.021 1.09.078 1.647.226C21.863 11.696 23 12.935 23 15c0 3.044-2.829 4.463-5.726 4.151C15.923 21.682 13.486 23 10 23c-5.62 0-8.682-3.437-8.976-9.91A2 2 0 012.973 11H18.45zm-1.921 2H3.022c.248 5.468 2.504 8 6.978 8 4.452 0 6.577-2.518 6.53-8zm2 .01l-.003.334c-.015 1.436-.178 2.72-.486 3.846C19.662 17.185 21 16.38 21 15c0-1.079-.468-1.589-1.418-1.842a4.659 4.659 0 00-1.052-.149zM5.423 1.093C6.47 1.583 7 2.57 7 3.867c0 .963-.368 1.478-1.318 2.364-.55.514-.682.699-.682.902 0 .57.138.828.423.96a1 1 0 01-.846 1.813C3.53 9.417 3 8.43 3 7.133c0-.963.368-1.478 1.318-2.364.55-.514.682-.699.682-.902 0-.57-.138-.828-.423-.96a1 1 0 01.846-1.813zm10 0C16.47 1.583 17 2.57 17 3.867c0 .963-.368 1.478-1.318 2.364-.55.514-.682.699-.682.902 0 .57.138.828.423.96a1 1 0 01-.846 1.813C13.53 9.417 13 8.43 13 7.133c0-.963.368-1.478 1.318-2.364.55-.514.682-.699.682-.902 0-.57-.138-.828-.423-.96a1 1 0 01.846-1.813zM10.47.118C11.503.668 12 1.728 12 3.133c0 1.008-.353 1.572-1.27 2.55-.583.622-.73.858-.73 1.184 0 .728.17 1.09.47 1.25a1 1 0 11-.94 1.765C8.496 9.332 8 8.272 8 6.867c0-1.008.353-1.572 1.27-2.55.583-.622.73-.858.73-1.184 0-.728-.17-1.09-.47-1.25a1 1 0 01.94-1.765z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

